module.exports = __webpack_public_path__ + "03e05d741fc25d735c129f48ce245463.png";